import { useId, useMemo, useState } from "react";
import { verifySecurityQuestion } from "../../../services/authApi";
import { Input, Modal } from "@iq/models";
import { FaUserSecret } from "react-icons/fa";
import "./Modal.css";

function SecurityQuestionVerify({ profile, question, onComplete, onBack }) {
  const formId = useId();
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const canSubmit = !loading && Boolean(answer.trim());

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    if (!answer.trim()) return;

    setLoading(true);
    try {
      await verifySecurityQuestion(profile.id, answer.trim());
      onComplete();
    } catch (err) {
      setError("Incorrect answer. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  const actionButtons = useMemo(() => ([
    {
      key: "verify",
      text: loading ? "Verifying..." : "Verify Answer",
      type: "submit",
      form: formId,
      disabled: !canSubmit,
      color: "accent",
    },
  ]), [canSubmit, formId, loading]);

  return (
    <Modal
      isOpen={true}
      onClose={onBack}
      title="Security Question"
      icon={<FaUserSecret />}
      actionButtons={actionButtons}
      errorMessage={error}
      shrink={true}
    >
      <div className="sq-card">
        <div className="sq-header">
          <h2 className="sq-name">{profile.name}</h2>
        </div>

        <p className="sq-question">{question}</p>

        <form id={formId} onSubmit={handleSubmit} className="sq-form">
          <div className="sq-field">
            <Input
              name="answer"
              fieldClassName="sq-input"
              type="password"
              placeholder="Your answer"
              value={answer}
              onChange={(e) => { setAnswer(e.target.value); setError(""); }}
              autoComplete="off"
              autoFocus
              colorScheme="light"
            />
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default SecurityQuestionVerify;